import type { ReactNode } from "react";

interface DialogFooterProps {
  status?: ReactNode;
  children?: ReactNode;
}

/**
 * 다이얼로그 하단 공용 푸터: 왼쪽에 상태 텍스트(aria-live), 오른쪽에 액션 버튼들.
 */
const DialogFooter = (props: DialogFooterProps) => (
  <div className="flex min-w-0 flex-col justify-between gap-2 pt-2 sm:flex-row sm:items-center">
    <div aria-live="polite" className="text-muted-foreground min-w-0 flex-1 text-sm">
      {props.status}
    </div>
    <div className="flex min-w-0 max-w-full flex-wrap items-center justify-end gap-2">{props.children}</div>
  </div>
);

export default DialogFooter;
